import { render, staticRenderFns } from "./UploadSealModal.vue?vue&type=template&id=0fae4ff0&scoped=true&"
import script from "./UploadSealModal.vue?vue&type=script&lang=js&"
export * from "./UploadSealModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadSealModal.vue?vue&type=style&index=0&id=0fae4ff0&prod&scoped=true&lang=css&"
import style1 from "./UploadSealModal.vue?vue&type=style&index=1&id=0fae4ff0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fae4ff0",
  null
  
)

export default component.exports